import React, {useState} from 'react';
import { Formik, Form, Field } from 'formik';
import {
    Box,
    Button,
    ButtonGroup,
    Flex,
    FormControl,
    HStack,
    Radio,
    RadioGroup,
    Stack,
    Wrap,
    WrapItem
} from '@chakra-ui/react';
import { ThemedStyledInput } from '../../../components/Styled';
import * as Yup from 'yup';
import { CustomButton } from "../../../components/Styled/StyledButtons";
import { Icon } from "@iconify/react";
import FieldErrorMessage from "../../../components/FieldErrorMessage/FieldErrorMessage";

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .max(30, 'Search & Filters Error: Name must be 30 characters or less')
        .trim()
        .strict(true)
});

const PaymentsSearchFilter = ({ onFilterChange }) => {
    const [dateMode, setDateMode] = useState('single'); // 'single' or 'range'

    const initialValues = {
        name: '',
        email: '',
        createdDate: '',
        reference: '',
        startDate: '',
        endDate: ''
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
                const filters = { ...values };

                if (dateMode === 'single') {
                    if (!filters.createdDate) delete filters.createdDate;
                    delete filters.startDate;
                    delete filters.endDate;
                } else {
                    if (!(filters.startDate && filters.endDate)) {
                        delete filters.startDate;
                        delete filters.endDate;
                    }
                    delete filters.createdDate;
                }

                onFilterChange(filters);
                setSubmitting(false);
            }}
            onReset={() => {
                onFilterChange(initialValues);
            }}
        >
            {({ handleSubmit, resetForm }) => (
                <Form>
                    <Stack spacing={3}>
                        <Flex gap={4} flexWrap="wrap">
                            <FormControl flex="1" minW="250px">
                                <Field as={ThemedStyledInput} id="reference" name="reference" type="text" placeholder="Reference Number" />
                                <Box fontSize="xs" color="gray.300" mt={1}>Payment Reference</Box>
                            </FormControl>
                            <FormControl flex="1" minW="250px">
                                <Field as={ThemedStyledInput} id="name" name="name" type="text" placeholder="Customer FullName" />
                                <Box fontSize="xs" color="gray.300" mt={1}>Customer Full Name</Box>
                            </FormControl>
                            <FormControl flex="1" minW="250px">
                                <Field as={ThemedStyledInput} id="email" name="email" type="email" placeholder="Email" />
                                <Box fontSize="xs" color="gray.300" mt={1}>Customer Email</Box>
                            </FormControl>
                        </Flex>

                        <Flex gap={4} flexWrap="wrap" align="flex-start">

                            <Box>
                                <ButtonGroup isAttached variant="outline" size="md" colorScheme="gray">
                                    <Button
                                        variant={dateMode === 'single' ? 'solid' : 'outline'}
                                        onClick={() => setDateMode('single')}
                                    >
                                        Single Date
                                    </Button>
                                    <Button
                                        variant={dateMode === 'range' ? 'solid' : 'outline'}
                                        onClick={() => setDateMode('range')}
                                    >
                                        Date Range
                                    </Button>
                                </ButtonGroup>
                            </Box>

                            {dateMode === 'single' && (
                                <FormControl flex="1" minW="200px">
                                    <Field as={ThemedStyledInput} id="createdDate" name="createdDate" type="date" />
                                    <Box fontSize="xs" color="gray.300" mt={1}>Search by Payment Date</Box>
                                </FormControl>
                            )}
                            {dateMode === 'range' && (
                                <>
                                    <FormControl flex="1" minW="200px">
                                        <Field as={ThemedStyledInput} id="startDate" name="startDate" type="date" />
                                        <Box fontSize="xs" color="gray.300" mt={1}>Start of Date Range</Box>
                                    </FormControl>
                                    <FormControl flex="1" minW="200px">
                                        <Field as={ThemedStyledInput} id="endDate" name="endDate" type="date" />
                                        <Box fontSize="xs" color="gray.300" mt={1}>End of Date Range</Box>
                                    </FormControl>
                                </>
                            )}

                            <Box display="flex" alignItems="flex-end" gap={2} minW="200px">
                                <CustomButton
                                    onClick={handleSubmit}
                                    type="search"
                                    tooltipLabel="Search"
                                    icon={<Icon icon="bi:search" />}
                                    showLabel={false}
                                >
                                    Search
                                </CustomButton>
                                <CustomButton
                                    type="reset"
                                    onClick={resetForm}
                                    tooltipLabel="Clear Filters"
                                    icon={<Icon icon="radix-icons:reset" />}
                                    showLabel={false}
                                >
                                    Clear
                                </CustomButton>
                            </Box>
                        </Flex>
                        <FieldErrorMessage name="name" />
                        <FieldErrorMessage name="email" />
                    </Stack>
                </Form>
            )}
        </Formik>
    );
};

export default PaymentsSearchFilter;

